<template>
    <div class="documents-container position-relative">
        <div class="spinner-container position-absolute w-100 h-100 d-flex justify-content-center align-items-center" v-if="loadingFiles">
            <spring-spinner
                :animation-duration="3000"
                :size="60"
                color="#ff1d5e"
            />
        </div>
        <ul class="breadcrumbs">
            <li>
                <a @click="$store.dispatch('selectFolder', null)">Home</a>
                <span>/</span>
            </li>
            <li v-for="folderID in folderPath">
                <a @click="$store.dispatch('gotoFolder', folderID)">&nbsp;{{folders[folderID].name}}</a>
                <span>/</span>
            </li>
        </ul>
        <div class="row">
            <div class="col-3">
                <folders :parent-id="parentID" :is-root="true" :folders="parentFolders"></folders>
            </div>
            <div class="col-3">
                <folders :parent-id="currentFolderID" :is-root="false" :folders="currentFolders"></folders>
            </div>
            <div class="col-6">
                <files :files="currentFiles"></files>
            </div>
        </div>
        <sidebar></sidebar>
    </div>
</template>

<script>
    import folders from './Folders';
    import files from './Files';
    import Sidebar from "./Sidebar";
    import { SpringSpinner } from 'epic-spinners';
    import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';

    export default {
        components: {Sidebar, folders, files, SpringSpinner },
        props: {
            'id': {
                default: null,
                type: Number
            },
            'type': {
                default: null,
                type: String
            },
            'isDisabled': {
                default: false,
                type: Boolean
            },
            'isCore': {
                default: false,
                type: Boolean
            },

            'job': {
                type: Object,
                default: () => { return {} }
            }
        },

        mounted(){
            this.setJob(this.job);
            this.setJobType(this.type);
            this.setJobID(this.id);
            this.setIsDisabled(this.isDisabled);
            this.setIsCore(this.isCore);
            this.getFolders();

        },

        methods: {
            ...mapActions({
                getFolders: 'getFolders'
            }),
            ...mapMutations({
                setJob: 'setJob',
                setJobType: 'setJobType',
                setJobID: 'setJobID',
                setIsDisabled: 'setIsDisabled',
                setIsCore: 'setIsCore',
            })
        },

        computed: {
            ...mapGetters({
                parentFolders: 'getParentFolders',
                currentFolders: 'getCurrentFolders',
                currentFiles: 'getCurrentFiles',
                currentFolderID: 'getCurrentFolderID',
                parentID: 'getParentID',
            }),
            ...mapState({
                loadingFiles: 'loadingFiles',
                folderPath: 'currentFolderPath',
                currentFolderID: 'currentFolderID',
                folders: 'folders'
            })
        }
    }
</script>
